import type { TransformParamTypes } from '@/types/generics'

import {
  generateSrc,
  getAssetFilepathWithTransforms,
  getVideoBaseUrlByStrategy,
  isStaticUrl,
} from './helpers'

export const convertVideoToImageUrl = (url: string) => {
  const filename = getAssetFilepathWithTransforms(url)
  const splitFilename = filename.split('.')
  const extension = splitFilename[splitFilename.length - 1]

  return url.replace(extension, 'jpg')
}

export function generateVideoSrc(
  assetUrl: string,
  transformationParams: TransformParamTypes,
  width: number,
): string {
  if (isStaticUrl(assetUrl)) return assetUrl

  const strategy =
    import.meta.env.PUBLIC_VIDEO_TRANSFORM_STRATEGY || 'cloudinary'

  const videoBaseUrl = getVideoBaseUrlByStrategy(strategy)

  const url = generateSrc(
    assetUrl,
    transformationParams,
    width,
    strategy,
    'video',
  )

  return `${videoBaseUrl}${url}`
}

export const WIDTH_BUCKETS = [768, 1024, 1280]

export function getBucketedWidth(width: number): number {
  return WIDTH_BUCKETS.find((b) => b >= width) ?? WIDTH_BUCKETS.at(-1)!
}

export function getOptimizedVideoUrl(
  baseUrl: string,
  intersectingEl: { width: number; height: number },
): string {
  const { width, height } = intersectingEl
  const dpr = Math.min(window.devicePixelRatio ?? 1, 2)
  const bucketedWidth = getBucketedWidth(Math.round(width * dpr))
  const ar = (width / height).toFixed(2)

  return generateVideoSrc(baseUrl, { q: '60', ar }, bucketedWidth)
}
